import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { EntityLinker, ENTITY_TYPES, Button, useLinkedEntitiesContext } from "@adsk/bim360-matrix-react-components";
import { addLinkedEntitiesAction, removeLinkedEntityAction } from '../../../../../redux/actions';
import pco from "@adsk/bim360-matrix-react-components/es/plugins/pco";
import { issueAttributesType } from "../../../../../constants/proptype-validation";
import classNames from "classnames";
import { viewTypes } from "../../../../../constants/view-types";
import { getCurrentViewType, isCostEnabled } from "../../../../../redux/selectors";
import { connect } from "../../../../../redux/connect";

class IssuePreviewDetailsTabLinkedReferences extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pickerModalEntityType: null,
    };
    this.onAddRelationships = this.onAddRelationships.bind(this);
    this.onRemoveRelationship = this.onRemoveRelationship.bind(this);
    this.emptyStateRenderer = this.emptyStateRenderer.bind(this);
    this.emptyErrorRenderer = this.emptyErrorRenderer.bind(this);
    this.closePickerModal = this.closePickerModal.bind(this);

  }

  onAddRelationships(sourceEntity, entitiesToLink) {
    return new Promise((resolve, reject) => {
      const entities = entitiesToLink.map(({ id, type }) => { return { linkedItemId: id, linkedItemType: type }; });
      const onSuccess = (relationships) => {
        this.props.linkedEntityContext && this.props.linkedEntityContext.addRelationships && this.props.linkedEntityContext.addRelationships(relationships);
        resolve(relationships);
      };
      this.props.addLinkedEntitiesAction(sourceEntity, entities, onSuccess, reject);
    });
  }

  onRemoveRelationship(relationshipItem) {
    const { entities } = relationshipItem;
    return new Promise((resolve, reject) => {
      const { issue } = this.props;
      const entity = entities.find(({ id }) => id !== issue.id);
      const onSuccess = (relationship) => {
        this.props.linkedEntityContext && this.props.linkedEntityContext.removeRelationship && this.props.linkedEntityContext.removeRelationship(relationshipItem.id);
        resolve(relationship);
      };
      this.props.removeLinkedEntityAction(issue, { linkedItemId: entity.id, linkedItemType: entity.type }, onSuccess, reject);
    });
  }

  getNewPcoDescription() {
    const { issue } = this.props;
    let desc = `${T.translate('new.question')}:\n${issue.question}`;
    if (issue.suggestedAnswer) {
      desc += `\n\n${T.translate('new.suggestedAnswer')}:\n${issue.suggestedAnswer}`;
    }
    if (issue.officialResponse) {
      desc += `\n\n${T.translate('answer.officialResponse')}:\n${issue.officialResponse}`;
    }
    return desc;
  }

  closePickerModal() {
    this.setState({ pickerModalEntityType: null });
  }

  emptyStateRenderer() {
    const { issue, isCostEnabled } = this.props;
    const canEditLinkedEntities = isCostEnabled && issue.permittedActions && issue.permittedActions.linkPCO;

    return <React.Fragment>
      <div className="EntityLinker__title">{T.translate('issueAttributes.linkedReferences.references')}</div><div className="IssuePreviewDetailsTabLinkedReferences__empty">
        <div className="IssuePreviewDetailsTabLinkedReferences__empty-placeholder">{canEditLinkedEntities ? T.translate('issueAttributes.linkedReferences.placeholder') : T.translate('issueAttributes.linkedReferences.noReferences')}</div>
        {canEditLinkedEntities && <Button
          styleType={Button.StyleType.INLINE_LINK}
          onClick={() => {
            this.setState({
              pickerModalEntityType: ENTITY_TYPES.PCO,
            });
          }}
        >
          {T.translate('issueAttributes.linkedReferences.add')}
        </Button>}

      </div>
    </React.Fragment>;
  }

  emptyErrorRenderer({ retry }) {
    return <div className="IssuePreviewDetailsTabLinkedReferences__error">
      <span className="IssuePreviewDetailsTabLinkedReferences__error-title">{T.translate('issueAttributes.linkedReferences.label')}</span>
      <span className="IssuePreviewDetailsTabLinkedReferences__error-text">{T.translate('issueAttributes.linkedReferences.loadError')}</span>
      <Button
        className="IssuePreviewDetailsTabLinkedReferences__error-button"
        styleType={Button.StyleType.INLINE_LINK}
        onClick={retry}
      >
        {T.translate('issueAttributes.linkedReferences.tryAgain')}
      </Button>
    </div>;
  }

  render() {
    const { issue, viewType, container, isCostEnabled } = this.props;
    const divClassNames = classNames('IssuePreviewDetailsTabLinkedReferences', {
      'IssuePreviewDetailsTabLinkedReferences__narrow': viewType === viewTypes.DOCUMENT,
      'IssuePreviewDetailsTabLinkedReferences__wide': viewType === viewTypes.PROJECT,
    });
    const canEditLinkedEntities = isCostEnabled && issue.permittedActions && issue.permittedActions.linkPCO;
    const initialFields = {
      name: issue.title,
      description: this.getNewPcoDescription(),
    };

    const createFormProps = {
      initialFields,
      sourceEntityNumber: issue.customIdentifier || '',
      sourceEntityType: ENTITY_TYPES.RFI,
    };

    const plugins = [
      isCostEnabled && pco,
    ].filter(plugin => plugin);

    return (
      <div className={divClassNames}>
        <div className="IssuePreviewDetailsTabLinkedReferences__label">{T.translate('issueAttributes.linkedReferences.label')}</div>
        <div className="IssuePreviewDetailsTabLinkedReferences__fieldWrapper">
          <EntityLinker container={container} plugins={plugins} sourceEntityType={ENTITY_TYPES.RFI} sourceEntityId={issue.id}
            allowAddingLinks={canEditLinkedEntities}
            referenceListTitle={T.translate('issueAttributes.linkedReferences.references')}
            allowRemoveLinkedEntity={canEditLinkedEntities}
            hideTitleOnEmpty={true} pickerModalEntityType={this.state.pickerModalEntityType} closePickerModal={this.closePickerModal} showTitleInEmptyBlockError
            onAddRelationships={this.onAddRelationships} onRemove={this.onRemoveRelationship} createFormProps={createFormProps} emptyStateRenderer={this.emptyStateRenderer}
            emptyErrorRenderer={this.emptyErrorRenderer}
          />
        </div>
      </div>);
  }
}

IssuePreviewDetailsTabLinkedReferences.displayName = 'IssuePreviewDetailsTabLinkedReferences';

IssuePreviewDetailsTabLinkedReferences.propTypes = {
  container: PropTypes.object.isRequired,
  issue: issueAttributesType.isRequired,
  viewType: PropTypes.string.isRequired,
  addLinkedEntitiesAction: PropTypes.func.isRequired,
  removeLinkedEntityAction: PropTypes.func.isRequired,
  linkedEntityContext: PropTypes.object,
  isCostEnabled: PropTypes.object,
};


const mapStateToProps = (state) => {
  return {
    viewType: getCurrentViewType(state),
    isCostEnabled: isCostEnabled(state),
  };
};
const ConnectedIssuePreviewDetailsTabLinkedReferences = connect(mapStateToProps, { addLinkedEntitiesAction, removeLinkedEntityAction })(IssuePreviewDetailsTabLinkedReferences);

const WithLinkedEntitiesContext = (props) => {
  const linkedEntityContext = useLinkedEntitiesContext();
  return <ConnectedIssuePreviewDetailsTabLinkedReferences {...props} linkedEntityContext={linkedEntityContext} />;
};

export default WithLinkedEntitiesContext;

